<template>
  <v-row class="pb-4" no-gutters>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- Dialog copy monthly rates -->
    <dialog-copy-monthly-rates
      v-if="dialogCopyMonthlyRates"
      :dialog="dialogCopyMonthlyRates"
      resource="lcl"
      :monthyear="month_year_data"
      v-on:dialog-close="onCloseDialogCopyMonthlyRates"
    ></dialog-copy-monthly-rates>

    <!-- Dialog add suppliers -->
    <v-dialog v-model="dialogSuppliers" max-width="40%">
      <v-row no-gutters>
        <v-col>
          <v-card flat tile color="white">
            <v-card-title class="dialog-header-title">Choose Supplier</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <span>Suppliers:</span>
                  <v-autocomplete
                    class="form-control"
                    solo
                    flat
                    placeholder="Select supplier"
                    :items="sortedSuppliers"
                    item-text="name"
                    return-object
                    clearable
                    v-model="select_supplier_to_add"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content style="font-size: 90%">
                        <v-list-item-title v-html="data.item.label"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:item="data">
                      <img
                        :src="CONSTANT.getFlag(data.item.code_country)"
                        class="country-flag"
                      />
                      <v-list-item-content style="font-size: 90%">
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="end" class="mr-4">
                <v-btn
                  tile
                  depressed
                  small
                  color="primary"
                  class="font-weight-bold mr-4"
                  @click="addNewSupplier"
                  >ADD</v-btn
                >
                <v-btn
                  tile
                  depressed
                  small
                  color="error"
                  class="font-weight-bold"
                  @click="dialogSuppliers = false"
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>

    <!-- Dialog suppliers rates -->
    <v-dialog v-model="dialogSuppliersRates" max-width="90%">
      <v-row no-gutters>
        <v-col>
          <v-card flat tile color="white">
            <v-card-title class="dialog-header-title"
              >{{ port_pair_dgc }} Suppliers Pricing Rates</v-card-title
            >

            <v-card-text class="pa-2">
              <v-row no-gutters>
                <v-col>
                  <v-card flat tile color="white">
                    <v-data-table
                      :headers="suppliersMonthsHeaders"
                      :items="priceTableData"
                      hide-default-footer
                      no-data-text="No Rates"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr>
                            <td style="width: 130px" class="font-weight-bold">Price</td>
                            <template v-if="items.length == 0">
                              <td colspan="12"></td>
                            </template>

                            <template v-else>
                              <template v-for="(rate, rkey) in items">
                                <td
                                  :key="rkey"
                                  :style="
                                    rkey == 5
                                      ? 'background-color:#B2DFDB;'
                                      : 'background-color:#FFFFFF;'
                                  "
                                >
                                  <v-row class="fill-height">
                                    <pt-rates-cell-price
                                      :pt-item="rate"
                                      :rates="rate"
                                      :display="'supplier'"
                                      v-on:update-rate="onUpdatePricingReference"
                                      v-on:delete-rate="deletePricingTableRate"
                                    ></pt-rates-cell-price>
                                  </v-row>
                                </td>
                              </template>
                            </template>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-divider></v-divider>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <!-- <v-card v-if="suppliersTableData.length > 0"> -->
                  <v-card flat tile color="white">
                    <v-data-table
                      :headers="suppliersMonthsHeaders"
                      :items="sortedPortPairSuppliers"
                      hide-default-footer
                      no-data-text="No Rates"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="(item, ind) in items" :key="ind">
                            <td style="width: 130px">
                              <v-row no-gutters class="pl-1">
                                <v-col>
                                  <span
                                    style="font-size: 10px"
                                    :class="
                                      item.trash
                                        ? 'error--text lighten-5 font-weight-bold'
                                        : 'font-weight-bold'
                                    "
                                  >
                                    {{ supplierDictionary[item.supplier_id].short_name }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col v-if="item.default">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on" size="20" color="success"
                                        >mdi-account-check</v-icon
                                      >
                                    </template>
                                    Default supplier
                                  </v-tooltip>
                                </v-col>
                                <v-col v-else>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        x-small
                                        color="grey"
                                        @click="setSupplierAsDefault(item)"
                                      >
                                        <v-icon size="20">mdi-account-check</v-icon>
                                      </v-btn>
                                    </template>
                                    Set supplier as default
                                  </v-tooltip>
                                </v-col>
                                <v-col class="d-flex justify-end">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        x-small
                                        icon
                                        :color="item.trash ? 'error' : 'grey'"
                                        @click="trashUntrashSupplier(item)"
                                      >
                                        <v-icon size="20">mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    {{
                                      item.trash ? "Untrash supplier" : "Trash supplier"
                                    }}
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                            <template v-if="item.rates.length == 0">
                              <td colspan="12"></td>
                            </template>

                            <template v-else>
                              <template v-for="(rate, rkey) in item.rates">
                                <td
                                  :key="rkey"
                                  :style="
                                    rkey == 5
                                      ? 'background-color:#B2DFDB'
                                      : 'background-color:#FFFFFF'
                                  "
                                >
                                  <v-row class="fill-height">
                                    <pt-rates-cell-cost
                                      :pt-item="item"
                                      :rates="rate"
                                      v-on:update-rate="onUpdatePTSupplierRate"
                                      v-on:delete-rate="deletePricingTableRate"
                                    ></pt-rates-cell-cost>
                                  </v-row>
                                </td>
                              </template>
                            </template>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="end" class="mr-5">
                <v-btn
                  small
                  tile
                  depressed
                  color="primary"
                  class="font-weight-bold mr-4"
                  @click="onAddNewSupplier"
                  >ADD SUPPLIER</v-btn
                >
                <v-btn
                  small
                  tile
                  depressed
                  color="error"
                  class="font-weight-bold"
                  @click="dialogSuppliersRates = false"
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>

    <v-row no-gutters>
      <v-col class="d-flex justify-start">
        <v-toolbar flat height="50px">
          <v-toolbar-title class="primary--text">LCL Freight Charges</v-toolbar-title>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small icon color="primary" @click="onNewItem" class="mx-4">
                <v-icon>mdi-table-plus</v-icon>
              </v-btn>
            </template>
            Add new pricing item
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                icon
                color="primary"
                @click="onOpenDialogCopyMonthlyRates"
              >
                <v-icon size="22">mdi-content-copy</v-icon>
              </v-btn>
            </template>
            Copy monthly rates into a new month
          </v-tooltip>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="my-0"></v-divider>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <span>Origin Port:</span>
        <v-autocomplete
          class="form-control"
          solo
          flat
          placeholder="Select port"
          :items="sortedPortList"
          item-text="label"
          item-value="un_code"
          clearable
          v-model="filter_port_origin"
        >
          <template v-slot:item="data">
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:item="data">
            <img :src="CONSTANT.getFlag(data.item.code_country)" class="country-flag" />
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="3" md="2">
        <span>DG Class Code:</span>
        <v-select
          class="form-control"
          :items="dgClassCodes"
          solo
          flat
          v-model="filter_dg_class_code"
        ></v-select>
      </v-col>

      <v-col class="mt-4">
        <div
          class="custom-control custom-checkbox"
          style="height: 36px; padding-top: 10px; display: inline-block"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            id="filterShowTrash"
            v-model="filter_show_trash"
          />
          <label
            class="custom-control-label"
            for="filterShowTrash"
            style="padding-top: 1px"
            >Show trashed</label
          >
        </div>
      </v-col>

      <v-col cols="12" sm="3" md="2" class="pt-10">
        <v-btn
          small
          color="primary"
          class="font-weight-bold"
          tile
          @click="loadPricingTable"
          >SEARCH</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="my-0"></v-divider>
    </v-row>

    <v-row no-gutters class="mt-2 mb-1">
      <v-col cols="4" class="pl-3 d-flex justify-content-start align-end">
        <span class="primary--text font-italic font-weight-bold" style="font-size: 11px"
          >*You can add an extra supplier to a row from the row suppliers' dialog</span
        >
      </v-col>
      <v-col cols="3" class="d-flex justify-center">
        <input
          class="form-control rounded-0"
          v-model="searchTable"
          placeholder="Search destination port code"
        />
      </v-col>
    </v-row>

    <v-row dense class="px-1">
      <v-col>
        <v-card tile color="white">
          <v-data-table
            :search="searchTable"
            :headers="monthsHeaders"
            :items="tableData"
            :items-per-page="20"
            no-data-text="No Monthly Rates"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, ind) in items" :key="ind">
                  <td style="width: 120px">
                    <v-row no-gutters class="fill-height pl-1 pt-1">
                      <v-col>
                        <v-row>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                style="font-size: 10px"
                                :class="
                                  portDictionary[item.port_destination_un_code]
                                    ? 'font-weight-bold'
                                    : 'error--text font-weight-bold'
                                "
                                >{{ item.port_destination_un_code }}</span
                              >
                            </template>
                            {{
                              portDictionary[item.port_destination_un_code]
                                ? portDictionary[item.port_destination_un_code].name
                                : "Port not supported"
                            }}
                          </v-tooltip>
                        </v-row>

                        <v-row class="pt-2" justify="start">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                style="height: 15px"
                                class="pb-1 mr-1"
                                :color="$root.get_dgc_icon(item.dg_class_code).color"
                                size="12"
                              >
                                {{ $root.get_dgc_icon(item.dg_class_code).icon }}
                              </v-icon>
                            </template>
                            {{ $root.get_dgc_icon(item.dg_class_code).title }}
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-badge
                                class="font-weight-bold"
                                :content="item.suppliers.length"
                                :value="item.suppliers.length - 1"
                                color="amber darken-4"
                                overlap
                                bordered
                                offset-x="13"
                                offset-y="7"
                              >
                                <v-btn
                                  x-small
                                  class="pb-2 px-0 mx-1"
                                  v-on="on"
                                  icon
                                  @click="onDisplaySuppliersRates(item)"
                                >
                                  <v-icon size="20" color="teal"
                                    >mdi-account-supervisor-circle</v-icon
                                  >
                                </v-btn>
                              </v-badge>
                            </template>
                            Display supplier(s) rates
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                class="pb-2 ml-2 mr-1"
                                color="primary"
                                @click="onUpdateItem(item)"
                              >
                                <v-icon size="20">mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            Edit port information
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                class="pb-2"
                                :color="item.trash ? 'error' : 'grey'"
                                @click="trashUntrashPPItem(item)"
                              >
                                <v-icon size="20">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            {{ item.trash ? "Untrash item" : "Trash item" }}
                          </v-tooltip>
                        </v-row>
                      </v-col>
                    </v-row>
                  </td>

                  <template v-if="!item.prices.length">
                    <td colspan="12"></td>
                  </template>

                  <template v-else>
                    <template v-for="(rate, rkey) in item.prices">
                      <td
                        :key="rkey"
                        class="custom-table-tr"
                        :style="
                          rkey == 5
                            ? 'background-color:#B2DFDB'
                            : 'background-color:#FFFFFF'
                        "
                      >
                        <v-row
                          style="cursor: pointer"
                          class="fill-height"
                          @click="onDisplaySuppliersRates(item)"
                        >
                          <pt-rates-cell-price
                            :pt-item="item"
                            :rates="rate"
                          ></pt-rates-cell-price>
                        </v-row>
                      </td>
                    </template>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogUpdateRate"
      persistent
      :max-width="is_price ? '500px' : '800px'"
    >
      <v-row no-gutters>
        <v-col>
          <v-card color="white" v-if="pt_rate_obj != null" flat tile>
            <v-card-title class="dialog-header-title">
              {{ updatedTitleRateDialog }}
            </v-card-title>
            <!-- <v-alert v-model="alert" :type="alertType" dismissible>{{alertMessage}}</v-alert> -->
            <v-card-text class="mt-0 pt-0">
              <v-row no-gutters>
                <v-col>
                  <v-row>
                    <v-col v-if="!is_price">
                      <span>Supplier:</span>
                      <input
                        class="form-control"
                        disabled
                        v-model="pt_rate_obj.supplier.name"
                      />
                    </v-col>

                    <template v-if="is_price">
                      <v-col>
                        <span>UOM:</span>
                        <v-select
                          class="form-control"
                          :items="inputUOM"
                          return-object
                          solo
                          flat
                          v-model="pt_rate_obj.uom"
                        ></v-select>
                      </v-col>

                      <v-col>
                        <span>Currency:</span>
                        <v-select
                          :items="currencies"
                          solo
                          flat
                          class="form-control"
                          v-model="pt_rate_obj.currency"
                        ></v-select>
                      </v-col>

                      <v-col>
                        <span>Round-Up Qty:</span>
                        <input
                          type="number"
                          class="form-control"
                          v-model="pt_rate_obj.roundup_qty"
                        />
                      </v-col>
                    </template>
                  </v-row>

                  <v-row>
                    <template v-if="is_price">
                      <v-col>
                        <span>Price:</span>
                        <input class="form-control" v-model="pt_rate_obj.price.price" />
                      </v-col>

                      <v-col>
                        <span>Min. Price:</span>
                        <input
                          class="form-control"
                          v-model="pt_rate_obj.price.min_price"
                        />
                      </v-col>
                    </template>

                    <template v-if="!is_price">
                      <v-col>
                        <span>Cost:</span>
                        <input class="form-control" v-model="pt_rate_obj.cost.cost" />
                      </v-col>

                      <v-col>
                        <span>Min. Cost:</span>
                        <input class="form-control" v-model="pt_rate_obj.cost.min_cost" />
                      </v-col>

                      <v-col>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">LSS:</span>
                          </template>
                          Low Sulfur Surcharge
                        </v-tooltip>
                        <input
                          class="form-control"
                          v-model="pt_rate_obj.charges.low_sulfur_surcharge"
                        />
                      </v-col>

                      <v-col>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">BAF:</span>
                          </template>
                          Bunker Adjustment Factor
                        </v-tooltip>
                        <input
                          class="form-control"
                          v-model="pt_rate_obj.charges.bunker_adjustment_factor"
                        />
                      </v-col>

                      <v-col>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">ECRS:</span>
                          </template>
                          Emergency Cost Recovery Surcharge
                        </v-tooltip>
                        <input
                          class="form-control"
                          v-model="pt_rate_obj.charges.emergency_cost_recovery_surcharge"
                        />
                      </v-col>

                      <v-col>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">PSC:</span>
                          </template>
                          Peak Season Surcharge
                        </v-tooltip>
                        <input
                          class="form-control"
                          v-model="pt_rate_obj.charges.peak_season_surcharge"
                        />
                      </v-col>
                    </template>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="center" no-gutters>
                <v-btn
                  v-if="edit_pr"
                  @click="savePricingTableRate"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  >SAVE</v-btn
                >
                <v-btn
                  v-else
                  @click="addPricingTableRate"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  >CREATE</v-btn
                >
                <v-btn
                  @click="dialogUpdateRate = false"
                  dark
                  class="font-weight-bold ml-2"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>

    <v-dialog v-model="dialogUpdateItem" persistent max-width="800px">
      <v-row no-gutters>
        <v-col>
          <v-card color="white" v-if="pt_obj != null" flat tile>
            <v-card-title class="dialog-header-title">{{
              updateTitleItemDialog
            }}</v-card-title>
            <v-card-text class="mt-0 pt-0">
              <v-row no-gutters>
                <v-col>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <span>Origin Port:</span>
                      <v-autocomplete
                        class="form-control"
                        solo
                        flat
                        placeholder="Select port"
                        :items="sortedPortList"
                        item-text="label"
                        item-value="un_code"
                        clearable
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.port_origin_un_code"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:item="data">
                          <img
                            :src="CONSTANT.getFlag(data.item.code_country)"
                            class="country-flag"
                          />
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <span>Destination Port:</span>
                      <v-autocomplete
                        class="form-control"
                        solo
                        flat
                        placeholder="Select port"
                        :items="sortedPortList"
                        item-text="label"
                        item-value="un_code"
                        clearable
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.port_destination_un_code"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:item="data">
                          <img
                            :src="CONSTANT.getFlag(data.item.code_country)"
                            class="country-flag"
                          />
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row v-if="pt_obj.pt_id">
                    <template v-for="(sid, index) in pt_obj.suppliers">
                      <v-chip
                        :key="index"
                        label
                        small
                        color="teal"
                        dark
                        class="font-weight-bold mx-2 px-1"
                        style="font-size: 11px"
                        >{{ supplierDictionary[sid].name }}</v-chip
                      >
                    </template>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="7" v-if="pt_obj.pt_id == null">
                      <span>Supplier:</span>
                      <v-autocomplete
                        class="form-control"
                        solo
                        flat
                        placeholder="Select supplier"
                        :items="sortedSuppliers"
                        item-text="name"
                        item-value="company_id"
                        clearable
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="append_supplier"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:item="data">
                          <img
                            :src="CONSTANT.getFlag(data.item.code_country)"
                            class="country-flag"
                          />
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="3">
                      <span>DG class code:</span>
                      <v-select
                        class="form-control"
                        :items="inputDGClassCode"
                        return-object
                        solo
                        flat
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.dg_class_code"
                      ></v-select>
                    </v-col>

                    <v-col cols="3">
                      <span>Code:</span>
                      <input class="form-control" v-model="pt_obj.code" />
                    </v-col>

                    <v-col cols="5">
                      <span>Description:</span>
                      <input class="form-control" v-model="pt_obj.description" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="end" class="mr-4">
                <v-btn
                  small
                  @click="savePPItem"
                  class="font-weight-bold mr-4"
                  color="primary"
                  tile
                  depressed
                  >SAVE</v-btn
                >
                <v-btn
                  small
                  @click="onCloseDialogUpdateItem"
                  class="font-weight-bold"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>

<script>
import constant from "@/const";
import PtRatesCellPrice from "@/components/shared/pt/PtRatesCellPrice.vue";
import PtRatesCellCost from "@/components/shared/pt/PtRatesCellCost.vue";
import DialogCopyMonthlyRates from "@/components/admin/dialogs/DialogCopyMonthlyRates";
export default {
  components: {
    PtRatesCellPrice,
    PtRatesCellCost,
    DialogCopyMonthlyRates,
  },
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      CONSTANT: constant,
      filter_port_origin: "MYPKG", // default to Malaysia Port Klang
      filter_port_destination: null,
      filter_supplier: null,
      filter_dg_class_code: "ALL",
      filter_show_trash: true,

      currencies: [],

      search_port_pairs: "",

      supplierList: [],
      portList: [],

      dgClassCodes: ["ALL", "NON-DG", "DG-2", "DG-3"],
      inputDGClassCode: ["NON-DG", "DG-2", "DG-3"],
      inputUOM: ["RT", "QTL", "C3KG", "CW", "KG"],

      tableData: [],
      searchTable: "",
      suppliersTableData: [],
      priceTableData: [],

      month_year_data: null,

      mon_yr_headers: [],

      monthsHeaders: [
        {
          text: "Dest. Ports",
          align: "center",
          sortable: true,
          divider: true,
          value: "port_destination_un_code",
        },
      ],

      suppliersMonthsHeaders: [],

      edit_pr: true,
      is_price: false,

      dialogUpdateItem: false,
      dialogSuppliersRates: false,
      dialogUpdateRate: false,
      dialogSuppliers: false,
      selected_pp_item: {},
      select_supplier_to_add: null,

      dialogCopyMonthlyRates: false,

      updateTitleItemDialog: null,
      updatedTitleRateDialog: null,
      pt_obj: null,
      append_supplier: null,
      pt_rate_obj: null,
      port_pair_dgc: null,

      selected_rate_sync: {},
      selected_supplier_rate_sync: {},
    };
  },

  created() {},

  mounted() {
    this.fetch_ports();
    this.fetch_suppliers();
    this.fetch_mon_yr_headers();
    this.loadCurrenciesList();
  },

  watch: {
    append_supplier(val) {
      if (val != null) {
        this.pt_obj.suppliers = [val];
      } else {
        this.pt_obj.suppliers = [];
      }
    },
  },

  methods: {
    /**
     * fetch ports
     */
    async fetch_ports() {
      var resp = await this.$https.get("/api/ports?port_type=sea");
      this.portList = resp.data.data || [];
    },

    /**
     * fetch suppliers
     */
    async fetch_suppliers() {
      var resp = await this.$https.get("/api/company/list");
      this.supplierList = resp.data.data || [];
    },

    /**
     * Get currencies list
     */
    async loadCurrenciesList() {
      var resp = await this.$https.get("/api/currencies/list/dropdown");
      this.currencies = resp.data.data || [];
    },

    /**
     * fetch month year header for pricing rates
     */
    async fetch_mon_yr_headers() {
      var resp = await this.$https.get("/api/pts/mon_yr_headers/12");
      this.month_year_data = resp.data.month_year_data;

      this.mon_yr_headers = resp.data.data;
      this.mon_yr_headers.forEach((item) => {
        this.monthsHeaders.push({
          text: item,
          sortable: false,
          align: "center",
          divider: true,
        });
      });
    },

    /**
     * Reset the query filters parameters to their respectives default values
     */
    resetQueryFilterParams() {
      this.filter_port_origin = null;
      this.filter_port_destination = null;
      this.filter_supplier = null;
      this.filter_dg_class_code = "ALL";
      this.filter_show_trash = false;
    },

    /**
     *  open dialog copy monthly rates
     */
    onOpenDialogCopyMonthlyRates() {
      this.dialogCopyMonthlyRates = true;
    },

    /**
     *  close dialog copy monthly rates
     */
    onCloseDialogCopyMonthlyRates(hasChanged) {
      this.dialogCopyMonthlyRates = false;

      if (hasChanged) {
        this.loadPricingTable();
      }
    },

    /**
     * Query and fetch the Pricing Table Data
     */
    async loadPricingTable() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      var api_string = `/api/pts/lcl`;

      // origin port query value
      if (this.filter_port_origin) {
        api_string = `${api_string}?o_port=${this.filter_port_origin}`;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "Origin port is empty";
        this.$root.blockUIshow = false;
        return;
      }

      // trash query value
      if (this.filter_show_trash) {
        api_string = `${api_string}&trash=all`;
      }

      // // destination port query value
      // if (this.filter_port_destination) {
      //   api_string = `${api_string}&d_port=${this.filter_port_destination}`
      // }

      // dg class code query value
      if (this.filter_dg_class_code != "ALL") {
        api_string = `${api_string}&dgc_code=${this.filter_dg_class_code}`;
      }

      // // supplier query value
      // if (this.filter_supplier) {
      //   api_string = `${api_string}&supplier_id=${this.filter_supplier.company_id}`
      // }

      this.$root.blockUImsg = "Loading lcl price items...";
      this.$root.blockUIshow = true;

      var resp = await this.$https.get(api_string);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.tableData = resp.data.data || [];
      } else {
        this.tableData = [];
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    // /**
    //  * Load the Pricing Monthly Rates
    //  */
    // async loadRates(item) {
    //   this.$root.blockUImsg = "please wait..."
    //   this.$root.blockUIshow = true

    //   var resp = await this.$https.get(
    //     `/api/pts/lcl/${item.pt_id}/${item.suppliers[0]}/rates`
    //   )
    //   item.rates = resp.data.data

    //   // console.log("resp: ", resp.data);

    //   this.$root.blockUIshow = false
    // },

    /**
     * Load port pair suppliers rates
     */
    async onDisplaySuppliersRates(pp_item) {
      this.$root.blockUImsg = "loading suppliers...";
      this.$root.blockUIshow = true;
      this.suppliersTableData = [];
      this.selected_pp_item = pp_item;
      this.port_pair_dgc = `${pp_item.port_pair} (${pp_item.dg_class_code})`;
      // set the month year header
      this.suppliersMonthsHeaders = [
        {
          text: "",
          align: "center",
          sortable: false,
          divider: true,
          value: "supplier_id",
        },
      ];
      this.mon_yr_headers.forEach((item) => {
        this.suppliersMonthsHeaders.push({
          text: item,
          sortable: false,
          align: "center",
          divider: true,
        });
      });

      // get the suppliers
      let supplier_resp = await this.$https.get(
        `/api/pts/lcl/${pp_item.pt_id}/suppliers`
      );

      this.suppliersTableData = supplier_resp.data.data;
      this.priceTableData = pp_item.prices;

      this.dialogSuppliersRates = true;
      this.$root.blockUIshow = false;
    },

    /**
     * Set supplier as default
     */
    async setSupplierAsDefault(supplier) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(
        `/api/pts/lcl/${supplier.pt_id}/suppliers/${supplier.supplier_id}/set_default`
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the default supplier
        this.suppliersTableData.forEach((sup) => {
          if (sup.supplier_id == supplier.supplier_id) {
            sup.default = true;
          } else {
            sup.default = false;
          }
        });

        // set this supplier as default
        supplier.default = true;

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * Trash or Untrash supplier
     */
    async trashUntrashSupplier(supplier) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      // untrash if trash is true
      if (supplier.trash) {
        let resp = await this.$https.put(
          `/api/pts/lcl/${supplier.pt_id}/suppliers/${supplier.supplier_id}`
        );

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this supplier trash value to false
          supplier.trash = false;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      } else {
        let resp = await this.$https.delete(
          `/api/pts/lcl/${supplier.pt_id}/suppliers/${supplier.supplier_id}`
        );

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this supplier trash value to true
          supplier.trash = true;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      }
    },

    /**
     * on add new supplier
     */
    onAddNewSupplier() {
      this.dialogSuppliers = true;
    },

    /**
     * Add a new supplier
     */
    async addNewSupplier() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.post(
        `/api/pts/lcl/${this.selected_pp_item.pt_id}/suppliers/${this.select_supplier_to_add.company_id}`
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // add the new supplier rates to the list
        this.suppliersTableData.push(resp.data.data);

        // update the pp item
        this.selected_pp_item.suppliers.push(this.select_supplier_to_add.company_id);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.dialogSuppliers = true;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * On Update pricing cell
     */
    async onUpdatePricingReference(item, rate) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      if (rate.pt_my_id) {
        let resp = await this.$https.get(`/api/pts/lcl/monthly_rate/${rate.pt_my_id}`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // clone rate
          this.selected_rate_sync = rate;

          this.pt_rate_obj = resp.data.data;
          this.pt_rate_obj.is_price = true;
          this.pt_rate_obj.is_cost = false;

          this.updatedTitleRateDialog = `Update price reference for (${rate.month_year})`;
          this.edit_pr = true;
          this.is_price = true;
          this.dialogUpdateRate = true;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        // clone rate
        this.selected_rate_sync = rate;

        let resp = await this.$https.get(
          `/api/pts/lcl/monthly_rate/${rate.month_year}/prev_month?pt_id=${
            item.pt_id
          }&is_price=${true}`
        );

        this.pt_rate_obj = resp.data.data;

        // update pt rate obj
        this.pt_rate_obj.month = rate.month;
        this.pt_rate_obj.year = rate.year;
        this.pt_rate_obj.month_year = rate.month_year;
        this.pt_rate_obj.is_price = true;
        this.pt_rate_obj.pt_id = item.pt_id;
        this.pt_rate_obj.is_price = true;
        this.pt_rate_obj.is_cost = false;

        this.updatedTitleRateDialog = `Add new price reference for ${rate.month_year}`;
        this.edit_pr = false;
        this.is_price = true;
        this.dialogUpdateRate = true;
      }

      this.$root.blockUIshow = false;
    },

    // /**
    //  * on edit pt rate
    //  */
    // async onUpdatePTDefaultSupplierRate(item, rate) {
    //   this.$root.blockUImsg = "please wait..."
    //   this.$root.blockUIshow = true

    //   if (rate.pt_my_id) {
    //     let resp = await this.$https.get(
    //       `/api/pts/lcl/monthly_rate/${rate.pt_my_id}`
    //     )

    //     if (resp.data.status == constant.RESPONSE_STATUS_OK) {
    //       // clone rate
    //       this.selected_rate_sync = rate

    //       this.pt_rate_obj = resp.data.data

    //       this.updatedTitleRateDialog = `Update ${this.pt_rate_obj.pt_my_id} rate`
    //       this.edit_pr = true
    //       this.dialogUpdateRate = true
    //     } else {
    //       this.showSnackbar = true
    //       this.snackbarColor = "error"
    //       this.snackbarMsg = resp.data.msg
    //     }
    //   } else {
    //     // clone rate
    //     this.selected_rate_sync = rate

    //     // let resp = await this.$https.get(`/api/pts/lcl/init/rate`)
    //     let resp = await this.$https.get(
    //       `/api/pts/lcl/monthly_rate/${rate.month_year}/prev_month?pt_id=${item.pt_id}&sid=${item.suppliers[0]}`
    //     )
    //     this.pt_rate_obj = resp.data.data

    //     // update pt rate obj
    //     this.pt_rate_obj.month = rate.month
    //     this.pt_rate_obj.year = rate.year
    //     this.pt_rate_obj.month_year = rate.month_year
    //     this.pt_rate_obj.supplier_id = item.suppliers[0]
    //     this.pt_rate_obj.supplier = this.supplierDictionary[item.suppliers[0]]
    //     this.pt_rate_obj.pt_id = item.pt_id

    //     this.updatedTitleRateDialog = `Add PT-LCL+${rate.month_year}+${rate.pt_id}+${item.suppliers[0]} rate`
    //     this.edit_pr = false
    //     this.dialogUpdateRate = true
    //   }

    //   this.$root.blockUIshow = false
    // },

    /**
     * on edit pt rate from supplier's view
     */
    async onUpdatePTSupplierRate(item, rate) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      if (rate.pt_my_id) {
        let resp = await this.$https.get(`/api/pts/lcl/monthly_rate/${rate.pt_my_id}`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // clone rate
          this.selected_rate_sync = rate;

          this.pt_rate_obj = resp.data.data;
          this.pt_rate_obj.is_price = false;
          this.pt_rate_obj.is_cost = true;

          this.updatedTitleRateDialog = `Update supplier ${this.pt_rate_obj.month_year} cost`;
          this.edit_pr = true;
          this.is_price = false;
          this.dialogUpdateRate = true;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        // clone rate
        this.selected_rate_sync = rate;

        // let resp = await this.$https.get(`/api/pts/lcl/init/rate`)
        let resp = await this.$https.get(
          `/api/pts/lcl/monthly_rate/${rate.month_year}/prev_month?pt_id=${item.pt_id}&sid=${item.supplier_id}`
        );
        this.pt_rate_obj = resp.data.data;

        // update pt rate obj
        this.pt_rate_obj.month = rate.month;
        this.pt_rate_obj.year = rate.year;
        this.pt_rate_obj.month_year = rate.month_year;
        this.pt_rate_obj.supplier_id = item.supplier_id;
        this.pt_rate_obj.supplier = this.supplierDictionary[item.supplier_id];
        this.pt_rate_obj.pt_id = item.pt_id;
        this.pt_rate_obj.is_price = false;
        this.pt_rate_obj.is_cost = true;

        this.updatedTitleRateDialog = `Add supplier cost for ${rate.month_year}`;
        this.edit_pr = false;
        this.is_price = false;
        this.dialogUpdateRate = true;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * save pt rate (update existing data)
     */
    async savePricingTableRate() {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(
        `/api/pts/lcl/monthly_rate/${this.pt_rate_obj.pt_my_id}`,
        this.pt_rate_obj
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated rate
        this.selected_rate_sync = Object.assign(this.selected_rate_sync, resp.data.data);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
        this.dialogUpdateRate = false;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
      }
    },

    /**
     * add new pt rate
     */
    async addPricingTableRate() {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.post(`/api/pts/lcl/monthly_rate`, this.pt_rate_obj);

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated rate
        this.selected_rate_sync = Object.assign(this.selected_rate_sync, resp.data.data);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
        this.dialogUpdateRate = false;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
      }
    },

    /**
     * delete pt rate
     */
    async deletePricingTableRate(rate) {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.delete(`/api/pts/lcl/monthly_rate/${rate.pt_my_id}`);

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated rate
        rate = Object.assign(rate, resp.data.data);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
        this.dialogUpdateRate = false;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
      }
    },

    /**
     * On add new pp item
     */
    async onNewItem() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/pts/lcl/init`);
      this.pt_obj = resp.data.data;
      this.updateTitleItemDialog = "Add new LCL Port Pair DG Class";
      this.dialogUpdateItem = true;
      this.append_supplier = null;
      this.$root.blockUIshow = false;
    },

    /**
     * On updated pp item
     */
    async onUpdateItem(pp_item) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/pts/lcl/${pp_item.pt_id}`);
      this.pt_obj = resp.data.data;
      this.updateTitleItemDialog = `Update LCL ${this.pt_obj.pt_id}`;
      this.dialogUpdateItem = true;
      this.append_supplier = null;
      this.$root.blockUIshow = false;
    },

    /**
     * Save pp item
     */
    async savePPItem() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      try {
        // pt_id is null, then add
        if (this.pt_obj.pt_id == null) {
          // validate the pt obj input
          if (this.append_supplier == null || this.pt_obj.suppliers.length == 0) {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = "Please select a supplier";
            this.$root.blockUIshow = false;
            return;
          }

          let resp = await this.$https.post(`/api/pts/lcl`, this.pt_obj);
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.dialogUpdateItem = false;
            this.pt_obj = null;
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        } else {
          // if pt_id is not null, then update
          let resp = await this.$https.put(
            `/api/pts/lcl/${this.pt_obj.pt_id}`,
            this.pt_obj
          );
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.dialogUpdateItem = false;
            this.pt_obj = null;
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        }
      } catch (error) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = error;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Trash and Untrash pp item
     */
    async trashUntrashPPItem(pp_item) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      // untrash if trash is true
      if (pp_item.trash) {
        let resp = await this.$https.put(`/api/pts/lcl/${pp_item.pt_id}/untrash`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this pp_item trash value to false
          pp_item.trash = false;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      } else {
        let resp = await this.$https.delete(`/api/pts/lcl/${pp_item.pt_id}`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this pp_item trash value to true
          pp_item.trash = true;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      }
    },

    /**
     * On close the dialog update item
     */
    onCloseDialogUpdateItem() {
      this.dialogUpdateItem = false;
      this.pt_obj = null;
    },
  },

  computed: {
    sortedPortList() {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    sortedSuppliers() {
      return this.supplierList.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },

    sortedPortPairSuppliers() {
      // sort suppliers
      return this.suppliersTableData.sort(function (a, b) {
        return b.default - a.default;
      });
    },

    portDictionary() {
      var portDict = {};

      this.sortedPortList.forEach((element) => {
        portDict[element.un_code] = element;
      });

      return portDict;
    },

    supplierDictionary() {
      var suppDict = {};

      this.sortedSuppliers.forEach((element) => {
        // portDict.push({key: element.un_code, value: element})
        suppDict[element.company_id] = element;
      });

      return suppDict;
    },
  },
};
</script>

<style scoped>
.v-data-table {
  border: 2px solid #e0e0e0;
}
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}

.v-data-table tbody tr {
  text-align: left;
}

.v-data-table tbody tr .custom-table-tr {
  text-align: center;
}

.v-data-table td {
  padding: 0px;
  height: 30px;
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

::v-deep .v-badge__badge {
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  height: 18px;
  letter-spacing: 0;
  min-width: 18px;
  padding: 3px 5px;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-indent: 0;
  top: auto;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
}

.v-chip.v-size--x-small.chip-x-small-custom {
  font-size: 9px;
  height: 12px;
}
</style>
